import axios from "axios";

export const getData = (apiUrl, authToken, config = {}) => {
    if (authToken) {
        const {headers, ...otherConfig} = config;

        config = {
            'headers': {'Authorization': `Bearer ${authToken}`, ...config.headers},
            ...otherConfig
        }
    }

    return () => axios.get(apiUrl, config)
        .then(data => data)
        .catch(error => error.response)
}

export const postData = (apiUrl, requestData, authToken, config = {}) => {
    if (authToken) {
        const {headers, ...otherConfig} = config;

        config = {
            'headers': {'Authorization': `Bearer ${authToken}`, ...config.headers},
            ...otherConfig
        }
    }

    return () => axios.post(apiUrl, requestData, config)
        .then(data => data)
        .catch(error => error.response)
}

export const updateData = (apiUrl, requestData, authToken, config = {}) => {
    if (authToken) {
        const {headers, ...otherConfig} = config;

        config = {
            'headers': {'Authorization': `Bearer ${authToken}`, ...config.headers},
            ...otherConfig
        }
    }

    return () => axios.patch(apiUrl, requestData, config)
        .then(data => data)
        .catch(error => error.response)
}
// TODO place tokens and request data attr in right order
export const deleteData = (apiUrl, authToken, requestData = {}, config = {}) => {
    if (authToken) {
        const {headers, ...otherConfig} = config;

        config = {
            'headers': {'Authorization': `Bearer ${authToken}`, ...config.headers},
            'data': {
                ...requestData
            },
            ...otherConfig
        }
    }

    return () => axios.delete(apiUrl, config)
        .then(data => data)
        .catch(error => error.response)
}